import { render } from "./ShiftAccess.vue?vue&type=template&id=5e8e95e4"
import script from "./ShiftAccess.vue?vue&type=script&lang=js"
export * from "./ShiftAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__